import { Obj, Any, Cookie, Event } from '@kizmann/pico-js';
import { default as axios } from "axios";

axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest'
};

// Add a request interceptor
axios.interceptors.request.use(
    (config) => {

        let token = Cookie.get('sx-api-auth');

        if ( token ) {
            config.headers['Authorization'] = token;
        }

        Obj.get(config, 'onLoad', () => {
            //
        })();

        // Do something before request is sent
        return config;
    },
    (error) => {

        Obj.get(error.config, 'onDone', () => {
            //
        })();

        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
axios.interceptors.response.use(
    (response) => {

        Obj.get(response.config, 'onDone', () => {
            //
        })();

        let message = Obj.get(response, 'data.message');

        if ( !Any.isEmpty(message) ) {
            window.Notification.make(message, 'success');
        }

        let cookies = Obj.get(response, 'data.cookies', []);

        Obj.each(cookies, (val, key) => {
            Cookie.set(key, val, 60 * 60 * 24 * 180);
        });

        Event.fire('xhr.success', response.config.apx || []);

        // Do something with response data
        return response;
    },
    (error) => {

        Obj.get(error.config, 'onDone', () => {
            //
        })();

        let message = Obj.get(error, 'response.data.error');

        if ( !Any.isEmpty(message) ) {
            window.Notification.make(message, 'danger');
        }

        Event.fire('xhr.error', error.config.apx || []);

        // Do something with response error
        return Promise.reject(error.response);
    }
);